import { useState } from "react";
import type { CardPreviewProps } from "@/components/shapes/card-previews";
import { PreviewBody } from "@/components/shapes/shared/card-preview-parts";
import { GenericCardPreview } from "@/components/shapes/shared/generic-card-preview";
import { asString } from "@/components/shapes/shared/plain-record";

/** A saved item: its image, title and source. */
export function PreviewCardCardPreview(props: CardPreviewProps) {
  const { source, density } = props;
  const imageUrl = asString(source.imageUrl);
  const title = asString(source.title);
  const site = asString(source.source);
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const showImage = Boolean(imageUrl) && failedUrl !== imageUrl;
  if (!showImage && !title && !site) return <GenericCardPreview {...props} />;
  return (
    <div className="flex min-h-0 flex-col">
      {showImage && (
        <img
          src={imageUrl}
          alt=""
          // Its box is held at 4:3 while it loads, then follows the image.
          className="block max-h-[24em] w-full object-cover [aspect-ratio:auto_4/3]"
          data-testid="preview-card-card-image"
          draggable={false}
          loading="lazy"
          onError={() => setFailedUrl(imageUrl)}
        />
      )}
      {(title || site) && (
        <PreviewBody density={density} className="h-auto gap-[0.3em]">
          {title && (
            <p className="line-clamp-2 font-semibold text-card-ink">{title}</p>
          )}
          {site && (
            <p className="truncate text-[0.86em] text-card-muted">{site}</p>
          )}
        </PreviewBody>
      )}
    </div>
  );
}
